module.exports = __webpack_public_path__ + "akne_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/akne_2_before_tn.jpg
// module id = 1386
// module chunks = 0